import { render, staticRenderFns } from "./CampanhasOficiais.vue?vue&type=template&id=b311ac32&scoped=true"
import script from "./CampanhasOficiais.vue?vue&type=script&lang=js"
export * from "./CampanhasOficiais.vue?vue&type=script&lang=js"
import style0 from "./CampanhasOficiais.vue?vue&type=style&index=0&id=b311ac32&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b311ac32",
  null
  
)

export default component.exports